export { PropertySpecs } from './property-specs';
//# sourceMappingURL=index.js.map